import { serophinContactUrl } from "@serophin/shared";
import { Coffee } from "lucide-preact";
import { FacebookIcon, LinkedInIcon, ThreadsIcon, TwitterIcon } from "../components/icons";

const GENERAL_LINKS = [
  { name: "About", path: "/about" },
  { name: "Privacy", path: "/privacy" },
  { name: "Terms", path: "/terms" },
  { name: "FAQ", path: "/faq" },
  { name: "Contact", path: serophinContactUrl("nottldr") },
];

const SOCIAL_LINK_CLASS = "text-gray-900 dark:text-gray-100 hover:opacity-70 transition-opacity";

const SocialLinks = () => (
  <div class="mt-6 flex items-center justify-center space-x-4">
    <a href="https://x.com/nottldr_com" target="_blank" rel="noopener noreferrer" class={SOCIAL_LINK_CLASS} aria-label="Follow us on X (Twitter)">
      <TwitterIcon size={20} color="monochrome" />
    </a>
    <a href="https://www.linkedin.com/company/nottldr" target="_blank" rel="noopener noreferrer" class={SOCIAL_LINK_CLASS} aria-label="Follow us on LinkedIn">
      <LinkedInIcon size={20} color="monochrome" />
    </a>
    <a
      href="https://www.facebook.com/profile.php?id=61584569623443"
      target="_blank"
      rel="noopener noreferrer"
      class={SOCIAL_LINK_CLASS}
      aria-label="Follow us on Facebook"
    >
      <FacebookIcon size={20} color="monochrome" />
    </a>
    <a href="https://www.threads.com/@nottldr_com" target="_blank" rel="noopener noreferrer" class={SOCIAL_LINK_CLASS} aria-label="Follow us on Threads">
      <ThreadsIcon size={20} color="monochrome" />
    </a>
  </div>
);

const TipButton = () => (
  <div class="mt-6 flex items-center justify-center">
    <a
      href="/tip"
      class="font-bold text-sm text-neutral-50 flex items-center justify-center w-[150px] bg-indigo-600 hover:bg-indigo-700 rounded-lg px-4 py-2 cursor-pointer"
      data-test-click="tip-footer"
    >
      <Coffee class="w-4 h-4 inline-block mr-1" strokeWidth={3} />
      Tip me!
    </a>
  </div>
);

export const Footer = () => (
  <footer class="mb-20 mx-2 py-6 text-center text-gray-700 dark:text-gray-300 bg-white dark:bg-black rounded-2xl shadow-sm">
    <div>
      {GENERAL_LINKS.map((link, index) => (
        <span key={link.path}>
          <a href={link.path} class=" text-xs  hover:text-gray-800 dark:hover:text-gray-200">
            {link.name}
          </a>
          {index !== GENERAL_LINKS.length - 1 && <span class="mx-2">|</span>}
        </span>
      ))}
    </div>
    <TipButton />
    <div class="mt-8 pt-6 text-xs text-center flex items-center justify-center space-x-4 border-t border-neutral-200 dark:border-neutral-700">
      <span>Built with ❤️ in Sydney, Australia</span>
    </div>
    <SocialLinks />
    <div class="mt-6 text-xs text-center flex items-center justify-center space-x-4">
      <span class="inline-flex items-center gap-1.5">
        <img src="/static/logo/serophin_logo_64.png" alt="" width={16} height={16} class="size-4" />© {new Date().getUTCFullYear()}{" "}
        <a href="https://serophin.com" target="_blank" rel="noopener noreferrer" class="hover:underline">
          Serophin
        </a>
      </span>
    </div>
  </footer>
);
